import {
	Children,
	type FC,
	type ReactElement,
	cloneElement,
	isValidElement,
} from 'react';

import type { StepContentInterface } from './StepContent';
import type { StepLabelInterface } from './StepLabel';
import type { StepDetails } from './Stepper';

export interface StepInterface extends StepDetails {
	children: Array<ReactElement<StepLabelInterface | StepContentInterface>>;
}

export const Step: FC<StepInterface> = ({
	_index,
	_active,
	_last,
	children,
}) => {
	return (
		<div className="flex flex-col gap-2">
			<div className="flex flex-col">
				{Children.map(children, (child) => {
					if (isValidElement(child)) {
						return cloneElement(child, {
							_index,
							_active,
							_last,
						});
					}
				})}
			</div>
		</div>
	);
};
